import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  static targets = ["panel", "backdrop"]
  connect() {
    this.open = this.open.bind(this)
    window.addEventListener("resume:open-templates", this.open)
    // Portal to <body>: the editor lives inside .app-main-col (position:relative; z-index:10),
    // a stacking context the dashboard sidebar (z-50) sits above — so the modal can never paint
    // on top from inside it. Moving the element to <body> lets its z-index compete globally.
    if (this.element.parentElement !== document.body) document.body.appendChild(this.element)
  }
  disconnect() { window.removeEventListener("resume:open-templates", this.open) }
  open() { this.backdropTarget.classList.remove("hidden"); this.panelTarget.classList.add("rb-tpl-open") }
  close() { this.backdropTarget.classList.add("hidden"); this.panelTarget.classList.remove("rb-tpl-open") }
  pick(event) {
    const id = event.currentTarget.dataset.templateId
    const select = document.querySelector('select[name="resume[template_id]"]')
    if (select) { select.value = id; select.dispatchEvent(new Event("change", { bubbles: true })) }
    this.panelTarget.querySelectorAll("[data-template-modal-current]").forEach((b) => {
      const on = b.dataset.templateId === id
      b.classList.toggle("border-primary-fixed", on); b.classList.toggle("bg-primary-fixed/10", on)
      b.classList.toggle("border-outline-variant/30", !on)
    })
    this.close()
  }
}
